import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './GetApp.css';

// BestHand customer app store listings.
const APP_STORE = 'https://apps.apple.com/us/app/besthand/id6759716088';
const PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.worldtechnologiessolutionsllc.besthand&hl=en_US';

// Deferred deep link (Android): if we arrived with ?pro=<id>&service=<cat>
// (from a shared /pro link), pass them through the Play Store `referrer` param.
// The app reads it on first launch (Play Install Referrer) and opens that pro.
// iOS has no store-referrer → handled later via Branch.
function playUrlWithReferrer() {
  if (typeof window === 'undefined') return PLAY_STORE;
  try {
    const q = new URLSearchParams(window.location.search);
    const pro = q.get('pro');
    const service = q.get('service');
    if (!pro) return PLAY_STORE;
    const ref = encodeURIComponent(`pro=${pro}${service ? `&service=${service}` : ''}`);
    return `${PLAY_STORE}&referrer=${ref}`;
  } catch (e) {
    return PLAY_STORE;
  }
}

// Smart redirect: a phone scanning the QR lands here and is sent straight to the right store.
// Desktop visitors (rare) see both links as a fallback.
const GetApp = () => {
  React.useEffect(() => {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    let url = '';
    if (/iPhone|iPad|iPod/i.test(ua)) url = APP_STORE;
    else if (/Android/i.test(ua)) url = playUrlWithReferrer();
    if (url && typeof window !== 'undefined') window.location.replace(url);
  }, []);

  const playHref = typeof window !== 'undefined' ? playUrlWithReferrer() : PLAY_STORE;
  return (
    <div className={s.wrap}>
      <h1 className={s.h1}>Get the BestHand app</h1>
      <p className={s.p}>Opening your app store… if nothing happens, choose your store below.</p>
      <div className={s.badges}>
        <a className={s.badge} href={APP_STORE} target="_blank" rel="noopener noreferrer">App Store</a>
        <a className={s.badge} href={playHref} target="_blank" rel="noopener noreferrer">Google Play</a>
      </div>
    </div>
  );
};

export default withStyles(s)(GetApp);
